import { render, staticRenderFns } from "./recruit-item.vue?vue&type=template&id=24821168&scoped=true"
import script from "./recruit-item.vue?vue&type=script&lang=js"
export * from "./recruit-item.vue?vue&type=script&lang=js"
import style0 from "./recruit-item.vue?vue&type=style&index=0&id=24821168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24821168",
  null
  
)

export default component.exports